import React from 'react'
import Facilities from './Facilities'

import RequestFormStep1Facility from './step1Facility.js'

const RequestFormStep1 = () => {
  return (
    <div className="">
      <RequestFormStep1Facility />
      <Facilities />
    </div>
  )
}

export default RequestFormStep1
